import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function ManagementEnPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/christof-guenther-ict-management-dach.webp"
      texts={{
        title: "Management",
        heroClaimLine1: "Driven by expertise!",
        heroClaimLine2: "",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Management – Christof Günther | NetBasis International"
      metaDescription="Christof Günther leads B2B business development in the DACH region as an owner-operated, strategic partner with over 30 years of ICT expertise."
      metaOgUrl="https://net-basis.net/en/about-us/management"
    >
      <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-12">
        <div className="flex-shrink-0 flex justify-center md:justify-start">
          <div className="w-48 md:w-52 h-auto overflow-hidden rounded-lg border border-background-200">
            <img loading="lazy"
              src="https://net-basis.net/Bilder/CG-Foto.jpg"
              alt="Christof Günther"
              title="Christof Günther - NetBasis International"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex-1 space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          <h1 className="text-sm md:text-base font-semibold text-foreground-950 font-sans">
            Christof Günther – Founder, Owner, and your strategic mind for successful B2B business development in the DACH region.
          </h1>
          <p>
            <strong className="text-primary-600">NetBasis International</strong> was founded by him in Düsseldorf at the beginning of 2008 and has been owner-managed ever since.
          </p>
          <p>With more than 30 years of profound international experience in the ICT industry, he effectively helps foreign manufacturers open up new markets successfully with their technological products and solutions. His professional focus deliberately lies on all core areas of strategic and operational business development. Working in close cooperation, he develops comprehensive, future-proof market entry concepts for and with his business partners and reliably supports them in the practical execution and targeted management of their entire project undertakings.</p>
          <p>Furthermore, he makes his deep market knowledge and extensive industry insights available to interested companies through specialized consulting mandates as well as tailored training and individual coaching sessions.</p>
          <p>Prior to founding <strong className="text-primary-600">NetBasis International</strong>, Mr. Günther spent many years in responsible executive roles – including Branch Manager, Sales Director, and Export Manager – at medium-sized telecommunications and IT companies operating across Europe and worldwide. This long-standing management expertise forms the solid foundation for the sustainable success of your international projects.</p>
        </div>
      </div>
    </AboutSubPage>
  );
}